import { render, staticRenderFns } from "./InvestmentInstitutionsModal.vue?vue&type=template&id=15a6a5fa&scoped=true"
import script from "./InvestmentInstitutionsModal.vue?vue&type=script&lang=js"
export * from "./InvestmentInstitutionsModal.vue?vue&type=script&lang=js"
import style0 from "./InvestmentInstitutionsModal.vue?vue&type=style&index=0&id=15a6a5fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6a5fa",
  null
  
)

export default component.exports